import React from 'react';
import { Link } from 'react-router-dom';
import {
  BRAND_LOGO_SRC,
  BRAND_LOGO_FALLBACK_SRC,
  BRAND_LOGO_WIDTH,
  BRAND_LOGO_HEIGHT,
  BRAND_NAME
} from '../../constants/brand';

const SIZE_CLASS = {
  xs: 'h-6',
  sm: 'h-8',
  md: 'h-10',
  lg: 'h-12',
  xl: 'h-14'
};

const MAX_WIDTH_CLASS = {
  xs: 'max-w-[120px]',
  sm: 'max-w-[160px]',
  md: 'max-w-[200px]',
  lg: 'max-w-[240px]',
  xl: 'max-w-[280px]'
};

/**
 * Site wordmark. Logo already includes brand name - do not pair with text.
 */
const BrandLogo = ({
  to = '/',
  size = 'md',
  className = '',
  imgClassName = '',
  link = true,
  onClick,
  priority = false
}) => {
  const heightClass = SIZE_CLASS[size] || SIZE_CLASS.md;
  const maxWidthClass = MAX_WIDTH_CLASS[size] || MAX_WIDTH_CLASS.md;
  const image = (
    <img
      src={BRAND_LOGO_SRC}
      alt={BRAND_NAME}
      width={BRAND_LOGO_WIDTH}
      height={BRAND_LOGO_HEIGHT}
      className={`${heightClass} w-auto ${maxWidthClass} object-contain rounded-md ${imgClassName}`}
      decoding="async"
      loading={priority ? 'eager' : 'lazy'}
      fetchPriority={priority ? 'high' : 'auto'}
      onError={(e) => {
        if (e.currentTarget.src.endsWith('.webp')) {
          e.currentTarget.src = BRAND_LOGO_FALLBACK_SRC;
        }
      }}
    />
  );

  if (!link) {
    return (
      <span className={`inline-flex items-center ${className}`} onClick={onClick}>
        {image}
      </span>
    );
  }

  return (
    <Link
      to={to}
      onClick={onClick}
      className={`inline-flex items-center shrink-0 group ${className}`}
      aria-label={BRAND_NAME}
    >
      {image}
    </Link>
  );
};

export default BrandLogo;
